import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ManagementRequestGrid } from "../management-request-grid/ManagementRequestGrid";
import { managementAPI } from "../../../api/managementAPI/managementAPI";
import { Aside } from "../../components";
import LoadingOverlay from "react-loading-overlay-ts";

const ManagementContainer = (props) => {
  const [isActive, setActive] = useState(false);
  const [show, setShow] = useState({ status: false, message: "" });
  const [data, setDataGrid] = useState();

  useEffect(() => {
    setActive(true);
    try {
      managementAPI.getAllBlackList((res) => {
        if (!res || res.status !== 200) {
          setShow({
            status: true,
            message: "Errore durante il tentativo di ottenere dati.",
          });
        } else setDataGrid(res.data);
        setActive(false);
      });
    } catch (error) {
      setShow({
        status: true,
        message: "Errore durante il tentativo di ottenere dati.",
      });
    }
  }, []);

  const setActiveState = (state) => {
    setActive(state);
  };

  const handleDownload = async () => {
    setActive(true);
    var response = await managementAPI.exportExcel("FEED");

    if (response.status !== 200) {
      setShow({
        status: true,
        message: "Errore durante il tentativo di esportare il file.",
      });
    } else {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      let fileName = `BlackList.xlsx`;

      a.style.display = "none";
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    setActive(false);
  };

  return (
    <>
      <div>
        <LoadingOverlay active={isActive} spinner text="Loading ...">
          <div className="Management-page">
            <div className="row">
              <div className="Management-title">
                Consultazione
                <br></br>
              </div>
            </div>
            <div className="container border border-light">
              <div className="row justify-content-md-center">
                <ManagementRequestGrid
                  dataGrid={data}
                  show={show}
                  setShow={setShow}
                  setActive={setActiveState}
                  handleDownload={handleDownload}
                  setDataGrid={setDataGrid}
                />
              </div>
            </div>
          </div>
        </LoadingOverlay>
      </div>
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const Management = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementContainer);
